import React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";

import ListaParticipacoes from "./pages/ListaParticipacoes/index";
import Consulta from "./pages/Consulta/index";
import ListaContribuicoes from "./pages/ListaContribuicoes/index";
import Contribuicao from "./pages/Contribuicao/index";
import ParticipanteIdentifica from "./pages/ParticipanteIdentifica/index";
import ParticipanteNovo from "./pages/ParticipanteNovo/index";
import ParticipanteConfirma from "./pages/ParticipanteConfirma/index";
import ParticipanteEsqueciSenha from "./pages/ParticipanteEsqueciSenha/index";
import Login from "./pages/Login/index";
import Logout from "./pages/Logout/index";
import Identificado from "./pages/Identificado/index";
import Cancela from "./pages/Cancela/index";
import Rac from "./pages/Rac/index";
import PoliticaPrivacidade from "./pages/PoliticaPrivacidade";

export default function Routes() {
  return (
    <BrowserRouter>
      <Switch>
        <Route path="/" exact component={ListaParticipacoes} />
        <Route path="/Consulta/:consulta_id" exact component={Consulta} />
        <Route
          path="/Consulta/:consulta_id/Contribuicoes/"
          exact
          component={ListaContribuicoes}
        />
        <Route
          path="/Consulta/:consulta_id/Rac/"
          exact
          component={Rac}
        />
        <Route
          path="/Consulta/:consulta_id/Contribuicao/"
          exact
          component={Contribuicao}
        />
        <Route
          path="/Consulta/:consulta_id/Identifica"
          exact
          component={ParticipanteIdentifica}
        />
        <Route
          path="/Consulta/:consulta_id/NovoParticipante"
          exact
          component={ParticipanteNovo}
        />
        <Route
          path="/Consulta/:consulta_id/EsqueciSenha"
          exact
          component={ParticipanteEsqueciSenha}
        />
        <Route
          path="/Confirma/:token_id"
          exact
          component={ParticipanteConfirma}
        />   
        <Route
          path="/Login"
          exact
          component={Login}
        />
        <Route
          path="/Logout"
          exact
          component={Logout}
        />
        <Route
          path="/Identificado"
          exact
          component={Identificado}
        />
        <Route
          path="/Cancela/:email"
          exact
          component={Cancela}
        />
        <Route
          path="/PoliticaPrivacidade"
          exact
          component={PoliticaPrivacidade}
        />
      </Switch>
    </BrowserRouter>
  );
}
